import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Bot, MessageSquare, Settings, Play, FileText, ChevronRight, CheckSquare, AlertTriangle, X, Plus } from 'lucide-react';
const PROCEDURE_TABS = [{
  label: 'Library',
  path: ''
}, {
  label: 'AI Agents',
  path: 'ai-agents'
}, {
  label: 'Onboarding',
  path: 'onboarding'
}, {
  label: 'Analytics',
  path: 'analytics'
}];
const AGENTS = [{
  name: 'Troubleshooter',
  icon: '🤖',
  status: 'active',
  purpose: 'Pomaže zaposlenima da reše probleme tokom smene',
  knowledgeBase: 18,
  whatsapp: '+381 64 XXX XXXX',
  escalatesTo: 'Shift manager on duty',
  stats: {
    conversations: 47,
    resolved: '89%',
    escalated: '11%'
  }
}, {
  name: 'Onboarding Assistant',
  icon: '🎓',
  status: 'active',
  purpose: 'Guide new hires through training',
  knowledgeBase: 12,
  whatsapp: '+381 64 XXX XXXX',
  escalatesTo: 'HR Manager',
  stats: {
    conversations: 15,
    resolved: '93%',
    escalated: '7%'
  }
}, {
  name: 'Shift Helper',
  icon: '📋',
  status: 'draft',
  purpose: 'Daily tips, prep quantities',
  knowledgeBase: 5,
  whatsapp: 'Not connected',
  escalatesTo: 'None',
  stats: {
    conversations: 0,
    resolved: '0%',
    escalated: '0%'
  }
}];
export function AIAgents() {
  const [showTestChat, setShowTestChat] = useState(false);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2778">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-2779">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-2780">AI Agents</h1>
        <Button icon={<Plus size={16} data-id="element-2782" />} data-id="element-2781">Create Agent</Button>
      </div>

      <TabNavigation tabs={PROCEDURE_TABS} basePath="/procedures" data-id="element-2783" />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2784">
        {AGENTS.map((agent, i) => <Card key={i} className="flex flex-col h-full" data-id="element-2785">
            <div className="flex justify-between items-start mb-4" data-id="element-2786">
              <div className="flex items-center gap-3" data-id="element-2787">
                <div className="w-12 h-12 bg-accent-primary/10 rounded-xl flex items-center justify-center text-2xl" data-id="element-2788">
                  {agent.icon}
                </div>
                <div data-id="element-2789">
                  <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-2790">
                    {agent.name}
                    <span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${agent.status === 'active' ? 'bg-accent-success/10 text-accent-success' : 'bg-white/10 text-text-secondary'}`} data-id="element-2791">
                      ● {agent.status}
                    </span>
                  </h3>
                  <p className="text-text-secondary text-sm" data-id="element-2792">{agent.purpose}</p>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-6 flex-1" data-id="element-2793">
              <div className="flex justify-between text-sm p-2 bg-white/5 rounded" data-id="element-2794">
                <span className="text-text-secondary" data-id="element-2795">Knowledge base:</span>
                <span className="font-medium" data-id="element-2796">
                  {agent.knowledgeBase} documents
                </span>
              </div>
              <div className="flex justify-between text-sm p-2 bg-white/5 rounded" data-id="element-2797">
                <span className="text-text-secondary" data-id="element-2798">WhatsApp:</span>
                <span className="font-mono" data-id="element-2799">{agent.whatsapp}</span>
              </div>
              <div className="flex justify-between text-sm p-2 bg-white/5 rounded" data-id="element-2800">
                <span className="text-text-secondary" data-id="element-2801">Escalates to:</span>
                <span className="font-medium text-accent-warning" data-id="element-2802">
                  {agent.escalatesTo}
                </span>
              </div>
            </div>

            {agent.status === 'active' && <div className="grid grid-cols-3 gap-2 mb-6 text-center text-sm" data-id="element-2803">
                <div className="bg-background-elevated p-2 rounded" data-id="element-2804">
                  <div className="font-bold text-lg" data-id="element-2805">
                    {agent.stats.conversations}
                  </div>
                  <div className="text-[10px] text-text-secondary uppercase" data-id="element-2806">
                    Conversations
                  </div>
                </div>
                <div className="bg-background-elevated p-2 rounded" data-id="element-2807">
                  <div className="font-bold text-lg text-accent-success" data-id="element-2808">
                    {agent.stats.resolved}
                  </div>
                  <div className="text-[10px] text-text-secondary uppercase" data-id="element-2809">
                    Resolved
                  </div>
                </div>
                <div className="bg-background-elevated p-2 rounded" data-id="element-2810">
                  <div className="font-bold text-lg text-accent-warning" data-id="element-2811">
                    {agent.stats.escalated}
                  </div>
                  <div className="text-[10px] text-text-secondary uppercase" data-id="element-2812">
                    Escalated
                  </div>
                </div>
              </div>}

            <div className="flex gap-2 mt-auto pt-4 border-t border-white/5" data-id="element-2813">
              <Button className="flex-1" variant="secondary" icon={<Settings size={14} data-id="element-2815" />} data-id="element-2814">
                Configure
              </Button>
              <Button className="flex-1" variant="secondary" icon={<Play size={14} data-id="element-2817" />} onClick={() => setShowTestChat(true)} data-id="element-2816">
                Test
              </Button>
              <Button className="flex-1" variant="secondary" icon={<FileText size={14} data-id="element-2819" />} data-id="element-2818">
                View Logs
              </Button>
            </div>
          </Card>)}
      </div>

      {/* Configuration Preview (Static for now) */}
      <Card className="mt-8" data-id="element-2820">
        <h3 className="font-bold text-lg mb-6" data-id="element-2821">Agent Configuration Preview</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2822">
          <div data-id="element-2823">
            <h4 className="font-bold text-sm text-text-secondary uppercase mb-4" data-id="element-2824">
              Knowledge Base
            </h4>
            <div className="space-y-2 text-sm" data-id="element-2825">
              <label className="flex items-center gap-2" data-id="element-2826">
                <input type="checkbox" checked readOnly className="rounded bg-background border-white/10 text-accent-primary" data-id="element-2827" />
                <span data-id="element-2828">Kitchen Operations</span>
              </label>
              <div className="pl-6 space-y-2" data-id="element-2829">
                <label className="flex items-center gap-2" data-id="element-2830">
                  <input type="checkbox" checked readOnly className="rounded bg-background border-white/10 text-accent-primary" data-id="element-2831" />
                  <span data-id="element-2832">Burger Station SOP</span>
                </label>
                <label className="flex items-center gap-2" data-id="element-2833">
                  <input type="checkbox" checked readOnly className="rounded bg-background border-white/10 text-accent-primary" data-id="element-2834" />
                  <span data-id="element-2835">Pancake Station SOP</span>
                </label>
              </div>
              <label className="flex items-center gap-2" data-id="element-2836">
                <input type="checkbox" checked readOnly className="rounded bg-background border-white/10 text-accent-primary" data-id="element-2837" />
                <span data-id="element-2838">Equipment & Troubleshooting</span>
              </label>
            </div>
          </div>

          <div data-id="element-2839">
            <h4 className="font-bold text-sm text-text-secondary uppercase mb-4" data-id="element-2840">
              Behavior
            </h4>
            <div className="space-y-4" data-id="element-2841">
              <div data-id="element-2842">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-2843">
                  Tone
                </label>
                <div className="flex gap-2" data-id="element-2844">
                  <span className="px-3 py-1 bg-accent-primary text-white rounded text-sm" data-id="element-2845">
                    Formal
                  </span>
                  <span className="px-3 py-1 bg-white/5 text-text-secondary rounded text-sm" data-id="element-2846">
                    Friendly
                  </span>
                  <span className="px-3 py-1 bg-white/5 text-text-secondary rounded text-sm" data-id="element-2847">
                    Brief
                  </span>
                </div>
              </div>
              <div data-id="element-2848">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-2849">
                  Custom Instructions (Serbian)
                </label>
                <div className="bg-background border border-white/10 rounded p-3 text-sm text-text-secondary italic" data-id="element-2850">
                  Uvek pitaj na kojoj je lokaciji zaposleni. Za probleme sa
                  opremom, prvo pitaj da li su probali da restartuju. Za žalbe
                  kupaca, uvek predloži uključivanje vođe smene za refund {'>'}{' '}
                  500 RSD.
                </div>
              </div>
            </div>
          </div>

          <div data-id="element-2851">
            <h4 className="font-bold text-sm text-text-secondary uppercase mb-4" data-id="element-2852">
              Escalation Triggers
            </h4>
            <div className="space-y-2 text-sm" data-id="element-2853">
              <div className="flex items-center gap-2" data-id="element-2854">
                <CheckSquare size={16} className="text-accent-primary" data-id="element-2855" />
                <span data-id="element-2856">AI confidence {'<'} 70%</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2857">
                <CheckSquare size={16} className="text-accent-primary" data-id="element-2858" />
                <span data-id="element-2859">Health/safety keywords</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2860">
                <CheckSquare size={16} className="text-accent-primary" data-id="element-2861" />
                <span data-id="element-2862">Customer illness complaint</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2863">
                <CheckSquare size={16} className="text-accent-primary" data-id="element-2864" />
                <span data-id="element-2865">Refund {'>'} 500 RSD</span>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Test Chat Modal */}
      {showTestChat && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-2866">
          <Card className="w-full max-w-md h-[600px] flex flex-col p-0 overflow-hidden" data-id="element-2867">
            <div className="p-4 border-b border-white/10 flex justify-between items-center bg-background-elevated" data-id="element-2868">
              <div className="flex items-center gap-3" data-id="element-2869">
                <div className="w-8 h-8 bg-accent-primary/20 rounded-full flex items-center justify-center text-lg" data-id="element-2870">
                  🤖
                </div>
                <div data-id="element-2871">
                  <h3 className="font-bold" data-id="element-2872">Test: Troubleshooter</h3>
                  <div className="text-xs text-accent-success flex items-center gap-1" data-id="element-2873">
                    ● Online
                  </div>
                </div>
              </div>
              <button onClick={() => setShowTestChat(false)} className="text-text-secondary hover:text-white" data-id="element-2874">
                <X size={20} data-id="element-2875" />
              </button>
            </div>

            <div className="flex-1 bg-[#0b141a] p-4 overflow-y-auto space-y-4" data-id="element-2876">
              <div className="flex justify-end" data-id="element-2877">
                <div className="bg-[#005c4b] text-white p-3 rounded-lg rounded-tr-none max-w-[80%] text-sm" data-id="element-2878">
                  Gril temperatura pada, šta da radim?
                </div>
              </div>
              <div className="flex justify-start" data-id="element-2879">
                <div className="bg-[#202c33] text-white p-3 rounded-lg rounded-tl-none max-w-[80%] text-sm" data-id="element-2880">
                  Na kojoj lokaciji se nalazite?
                </div>
              </div>
              <div className="flex justify-end" data-id="element-2881">
                <div className="bg-[#005c4b] text-white p-3 rounded-lg rounded-tr-none max-w-[80%] text-sm" data-id="element-2882">
                  Vračar
                </div>
              </div>
              <div className="flex justify-start" data-id="element-2883">
                <div className="bg-[#202c33] text-white p-3 rounded-lg rounded-tl-none max-w-[80%] text-sm" data-id="element-2884">
                  Proverite dovod gasa i da li je termostat podešen na 250°C.
                  Ako je sve u redu, pokušajte da restartujete uređaj na glavnom
                  prekidaču.
                </div>
              </div>
            </div>

            <div className="p-3 bg-background-elevated border-t border-white/10 flex gap-2" data-id="element-2885">
              <input type="text" placeholder="Type a message..." className="flex-1 bg-[#2a3942] rounded-lg px-4 py-2 text-sm focus:outline-none text-white" data-id="element-2886" />
              <button className="p-2 bg-[#005c4b] rounded-full text-white" data-id="element-2887">
                <ChevronRight size={20} data-id="element-2888" />
              </button>
            </div>
          </Card>
        </div>}
    </div>;
}